import React from "react";

const PythonInovasiDigital: React.FC = () => {
  return (
    <div className="text-justify py-4 space-y-4">
      <p>
        Python Coding Competition merupakan ajang lomba pemrograman individu
        bagi siswa SMP dan SMA yang bertujuan membuka wawasan tentang
        pemrograman sebagai sarana inovasi digital. Di era transformasi
        teknologi yang berlangsung cepat, pemrograman tidak lagi dipandang
        sekadar menulis kode, melainkan sebagai alat untuk memahami cara kerja
        teknologi, menciptakan solusi, dan mengeksplorasi ide kreatif.{" "}
        <a
          href="https://www.python.org/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline font-medium"
        >
          Python
        </a>{" "}
        dipilih karena memiliki sintaks sederhana, fleksibel, dan mudah
        dipahami, sehingga mendukung proses belajar yang inklusif dan
        eksploratif.
      </p>

      <p>
        Berbeda dari kompetisi pemrograman yang menitikberatkan pada ketepatan
        algoritma semata, Python Coding Competition dalam ekosistem
        pembelajaran{" "}
        <strong>Indonesia Innovative Technology (IIT)</strong> menekankan
        pemrograman sebagai media berpikir dan bereksperimen. Peserta diajak
        menyelesaikan tantangan komputasional yang berkaitan dengan simulasi
        sederhana, pengolahan data dasar, serta perancangan logika program yang
        merepresentasikan permasalahan nyata. Melalui pendekatan ini, peserta
        memahami tidak hanya bagaimana menulis kode, tetapi juga alasan di
        balik perancangan sebuah solusi digital.
      </p>

      <p>
        Pendekatan tersebut sejalan dengan kompetisi seperti{" "}
        <a
          href="https://fokal.id/ct-codebattle-2025-cetak-anak-muda-percaya-diri-di-era-digital.html?utm_source=chatgpt.com"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline font-medium"
        >
          CT CodeBattle 2025
        </a>
        , yang mengusung coding challenge berbasis pemikiran komputasional.
        Dalam kompetisi semacam ini, Python digunakan sebagai alat untuk menguji
        kemampuan peserta dalam menganalisis masalah, merancang solusi, dan
        mengimplementasikannya dalam program yang dapat dijalankan. Tantangan
        dirancang untuk mendorong kreativitas, fleksibilitas berpikir, serta
        kemampuan beradaptasi terhadap berbagai skenario.
      </p>

      <p>
        Hasil dari proses ini terlihat dari beragam solusi yang dihasilkan
        peserta, mulai dari program logika interaktif, simulasi perhitungan
        berbasis data, hingga algoritma sederhana yang menggambarkan proses
        dunia nyata. Keberagaman pendekatan tersebut menunjukkan bahwa satu
        permasalahan dapat diselesaikan dengan berbagai cara yang sama-sama
        valid, sekaligus menanamkan pemahaman bahwa pemrograman adalah ruang
        kreativitas dan inovasi.
      </p>

      <p>
        Dalam konteks teknologi global seperti data science, kecerdasan buatan,
        dan otomasi, Python menjadi bahasa pemrograman yang banyak digunakan.
        Oleh karena itu, Python Coding Competition berperan sebagai sarana
        pembelajaran kontekstual untuk mengenalkan peserta pada cara berpikir
        inovator digital. Dengan dukungan ekosistem pembelajaran dari{" "}
        <a
          href="https://edukasi.accelist.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline font-medium"
        >
          Accelist Edukasi Indonesia (AEDU)
        </a>
        , kompetisi ini membantu peserta mengembangkan keterampilan abad ke-21
        seperti berpikir kritis, kreativitas, dan keberanian bereksperimen
        sebagai bekal menghadapi masa depan teknologi.
      </p>

      <p>👉 Cek untuk informasi Python Coding Competition lebih lanjut.</p>
    </div>
  );
};

export default PythonInovasiDigital;
